<ul>
    <li class="accordion-item" *ngFor="let step of reqSteps"><!-- details.steps -->
        <mat-checkbox [(ngModel)]="step.stepCompleted">{{step.stepName}}</mat-checkbox>
    </li>
</ul>


  <!-- <span *ngIf="step.document && step.document.length>0">
          DOC: {{step.document}}
        </span> -->

        <!-- <div class="medium-gray-title">Pasos a seguir</div>
        <div class="list list-outline list-dividers full-width">
            <ul *ngIf="step.type != 'form'">

                <li *ngFor="let item of step.checklist">
                    <label class="item-checkbox item-content checkbox-rounded">
                    <input type="checkbox" name="demo-checkbox" value="Books" checked="checked">
                    <i class="icon icon-checkbox"></i>
                    <div class="item-inner">
                        <div class="item-title">{{item}}</div>
                    </div>
                    </label>
                </li>
            
            
            </ul>

            <form *ngFor="let inputValue of reqSteps" >

              <span *ngFor="let questions of inputValue.form">
                <label for="title">{{questions.field}}</label>
                <input type="text" name="title">
              </span>
    
            </form>
        </div> -->